import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Shield, AlertCircle, Lock, Mail, Phone } from 'lucide-react';

const NoPermissions = () => {
  const { employee, logout } = useAuth();
  
  console.log('🔍 NoPermissions page - Employee data:', employee);
  console.log('🔍 NoPermissions page - Permissions:', employee?.permissions);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          {/* Icon */}
          <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Lock className="w-10 h-10 text-yellow-600" />
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            No Permissions Assigned
          </h1>
          
          {/* Message */}
          <p className="text-gray-600 mb-6">
            Your account doesn't have any permissions assigned yet. Please contact your administrator to get access to the system.
          </p>

          {/* Employee Info */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h3 className="text-sm font-medium text-gray-700 mb-3">Your Account Details</h3>
            <div className="space-y-2">
              <div className="flex items-center justify-center space-x-2">
                <Shield className="w-4 h-4 text-gray-400" />
                <span className="text-sm text-gray-600">{employee?.name}</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <Mail className="w-4 h-4 text-gray-400" />
                <span className="text-sm text-gray-600">{employee?.email}</span>
              </div>
              {employee?.phone && (
                <div className="flex items-center justify-center space-x-2">
                  <Phone className="w-4 h-4 text-gray-400" />
                  <span className="text-sm text-gray-600">{employee?.phone}</span>
                </div>
              )}
              <div className="flex items-center justify-center space-x-2">
                <AlertCircle className="w-4 h-4 text-gray-400" />
                <span className={`text-sm px-2 py-1 rounded-full ${
                  employee?.role === 'developer' ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white' :
                  employee?.role === 'admin' ? 'bg-red-100 text-red-800' :
                  employee?.role === 'manager' ? 'bg-blue-100 text-blue-800' :
                  'bg-purple-100 text-purple-800'
                }`}>
                  {employee?.role ? (employee.role.charAt(0).toUpperCase() + employee.role.slice(1)) : 'N/A'}
                </span>
              </div>
            </div>
          </div>

          {/* Instructions */}
          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <h3 className="text-sm font-medium text-blue-800 mb-2">What to do next:</h3>
            <ul className="text-sm text-blue-700 space-y-1 text-left">
              <li>• Contact your system administrator</li>
              <li>• Request access to the modules you need</li>
              <li>• Wait for permissions to be assigned</li>
              <li>• Refresh this page once permissions are granted</li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col space-y-3">
            <button
              onClick={() => {
                console.log('🔄 Force refreshing page...');
                // Clear all local storage
                localStorage.clear();
                // Force reload
                window.location.href = window.location.href;
              }}
              className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition-colors"
            >
              Refresh Page
            </button>
            <button
              onClick={() => {
                console.log('🚪 Force logout...');
                // Clear all local storage
                localStorage.clear();
                // Force redirect to login
                window.location.href = '/login';
              }}
              className="w-full bg-gray-200 text-gray-800 py-2 px-4 rounded-md hover:bg-gray-300 transition-colors"
            >
              Logout
            </button>
            <button
              onClick={() => {
                console.log('🧹 Clearing cache and reloading...');
                // Clear all storage
                localStorage.clear();
                sessionStorage.clear();
                // Clear cookies
                document.cookie.split(";").forEach(function(c) { 
                  document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
                });
                // Force reload
                window.location.href = '/login';
              }}
              className="w-full bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 transition-colors"
            >
              Clear Cache & Logout
            </button>
          </div>

          {/* Help Text */}
          <p className="text-xs text-gray-500 mt-6">
            If you believe this is an error, please contact your administrator with your account details shown above.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoPermissions;